import { useAuthKit } from '../contexts/AuthProvider';

/**
 * Org-wide role from the WorkOS JWT `role` claim, by EXACT slug
 * (ORIENTATION-ROLES P2). The old substring match made any slug with "admin"
 * in it (`site-admin`, `billing-admin`) an admin of every page.
 *
 *   admin             TurboTwin org admin: everything
 *   orientation-admin author and site admin on every site, no role changes
 *   orgviewer         trainee pages in the portal (D10)
 *   anything else     member: per-site rights only (`my_site_rights`)
 */
export type PortalRole = 'admin' | 'orientation-admin' | 'orgviewer' | 'member';

export function roleFromSlug(raw: string | null | undefined): PortalRole {
  const v = (raw ?? '').trim().toLowerCase();
  if (v === 'admin' || v === 'orientation-admin' || v === 'orgviewer') return v;
  return 'member';
}

export function useRole(): PortalRole {
  const { role } = useAuthKit();
  return roleFromSlug(role);
}

/** WorkOS `admin` (TurboTwin org admin). */
export function isAdmin(role: PortalRole): boolean {
  return role === 'admin';
}
